import React, { useEffect, useState }  from "react";
import { Helmet } from "react-helmet-async";


function YogaAndMeditation() {
    const [schedules, setSchedules] = useState([]);

    useEffect(() => {
      fetch(
        "https://script.google.com/macros/s/AKfycbxCkzaYNolVqq99kRcUUv0kCiPYm-_VzKcrTV2iPuyUizbAVvpJibaLN1ng3jCxTO2lJQ/exec"
      )
        .then((res) => res.json())
        .then((data) => setSchedules(data))
        .catch((err) => console.error("Failed to fetch schedules", err));
    }, []);
    
    return (
        <>
        <Helmet>
            <title>Yoga & Meditation | Adya Yoga</title>
            <meta
              name="description"
              content="Guided yoga and meditation sessions with class schedules. Hatha, Yin, Restorative, Yoga Nidra and more."
            />
            <link rel="canonical" href="https://yogaadya.com/yoga-and-meditation" />
            <meta name="robots" content="index, follow" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Adya Yoga" />
            <meta property="og:title" content="Yoga & Meditation | Adya Yoga" />
            <meta property="og:description" content="Guided yoga and meditation sessions and schedules by Jigyasa." />
            <meta property="og:url" content="https://yogaadya.com/yoga-and-meditation" />
            <meta property="og:image" content="https://yogaadya.com/assets/images/yoga_meditation_01.webp" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Yoga & Meditation | Adya Yoga" />
            <meta name="twitter:description" content="Hatha, Yin, Restorative, Yoga Nidra and more." />
            <meta name="twitter:image" content="https://yogaadya.com/assets/images/yoga_meditation_01.webp" />
        </Helmet>
        <section class="py-md-3 py-sm-3 py-3" id="yoga-meditation">
            <div className="events-retreats-container">
                {/* Header Section */}
                <div className="events-header">
                    <h1 className="events-title">Yoga & Meditaion</h1>                    
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <img src="assets/images/yoga_meditation_01.webp" alt="Yoga and Meditation" class="img-fluid"></img>
                    </div>
                </div>
                <div className ="row">                    
                    <div className ="col-lg-12 about-two-grids">                    
                    <div className ="about-para-txt text-center">
                        <p>I always try and find what are you really seeking from your practice, so you feel your
time spent on the Mat is worth it. My strong belief lies in the fact that each body is
different and dedication can bring in great results.</p>
<p>
Each session contains a good mix of Chanting, Pranayama, Asana and Meditation.
</p>
<p>
Hatha Yoga is a brilliant practice for the purification of the Body for higher practices
like Pranayama and Meditation. HATHA the word comprises of two terms- Ha (Sun)
and Tha (Moon). Having both heating and cooling effect it brings a balance in our
body and mind. Hatha Yoga is like a broad umbrella that covers different styles and
forms of Yoga. The science of postures, Asana Abhyasa, science of breath,
Pranayama, science of Meditation, Dhyaana, Science of guided sleep, Yoga Nidra
etc. all is covered in Hatha Yoga.
</p>
<p>
We also have Yin Yoga, Restorative Yoga, Chair Yoga, One to One Private Yoga Classes etc.
</p>
<p>
Yin Yoga is a slow paced style of yoga that targets the body’s deep connective
tissues like fascia, ligaments and tendons. Poses are held for around 3-10 minutes.
This practice emphasizes on a mindful approach towards our body.
</p>
<p>
Restorative Yoga is a slow practice which leads to a deep level of relaxation and
release of tension from the body and mind. This practice involves long holds, starting
from 5 minutes and going upto 20 minutes. It’s a passive practice and naturally
promotes overall wellbeing.
</p>
<p>
Our most loved offering is Yoga Nidra, which is a guided relaxation technique also
famously known as “yogic sleep”. With a structured format Yoga Nidra as a practice
can change your life.
</p>
<p><b>
<span className="text-center">“Ishwarapranidhanadva”</span><br></br>
“Inner peace can be achieved through complete devotion and surrender
(pranidhana) to God or a higher power (isvara)”</b>
</p>
                    </div>                    
                    </div>
                </div>
            </div>
            {/* Class Schedule Section */}
            <div className="events-retreats-container">
                <div className="events-header">
                    <h2 className="events-title">Class Schedule</h2>
                </div>
                <div className="row">
                    {schedules.map((item, index) => {
                        const hasBooking = item["BookingUrl"] && String(item["BookingUrl"]).trim() !== "";
                        const linkHref = hasBooking ? item["BookingUrl"] : "/contact";
                        const linkTarget = hasBooking ? "_blank" : undefined;
                        const linkRel = hasBooking ? "noopener noreferrer" : undefined;
                        return (
                            <div key={index} className="col-12 mb-4">
                                <div className="card h-100 shadow-sm">
                                    <img
                                        src={item["Image"]}
                                        alt={item["Discription"]}
                                        className="card-img-top img-fluid schedule-image"
                                    />
                                    <div className="card-body d-flex flex-column">
                                        <h5 className="card-title">{item["Discription"]}</h5>
                                        <a
                                            href={linkHref}
                                            className="register-btn mt-auto"
                                            target={linkTarget}
                                            rel={linkRel}
                                        >
                                            Book Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
        
        </>
    )
}

export default YogaAndMeditation;